import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

//  Actions - imported
import { editGroupName, editGroupDescription, editGroupPrivacy, getGroupById } from '../actions/groupActions';
import { setPage, add_To_Recent_History } from '../actions/navActions';

// wrapper layout
import Layout from '../components/layout/Layout';

// Modal
import Modal from '../components/modal/Modal';
import ModalContainer from '../components/modal/ModalContainer';

// Components
import { Button } from '@material-ui/core';
import Spinner from '../components/common/Spinner';
import ProfileHeader from '../components/Profile/ProfileHeader';
import Post from '../components/Post/Post';
import GroupEdit from '../components/GroupPage/GroupEdit';

const initialState = {
    group_name: '',
    description: '',
    location: null
};

const EditGroup = ({ 
    setPage,
    add_To_Recent_History,
    group: {
        group,
        loading
    },
    editGroupName, 
    editGroupDescription,
    editGroupPrivacy,
    getGroupById,
    match
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Input field data
    const [formData, setFormData] = useState(initialState);
    const [privacy, setPrivacy] = useState(null);

    // Edit info Modal toggle states
    const [nameModal, setNameModal] = useState(false);
    const [descriptionModal, setDescriptionModal] = useState(false);
    const [privacyModal, setPrivacyModal] = useState(false);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;

    // Set page on component mount
    useEffect(() => {
        setPage('group edit');
        add_To_Recent_History(url.pathname);  // current url
    }, []);

    // Get Group data by ID in url
    useEffect(() => {
        // Fetch the group data based on the `match.params.id` parameter
        getGroupById(match.params.id);

    }, [match.params.id])

    // Load form data whenever group changes
    useEffect(() => {

        // Load profile data
        if (!loading && group) {
            const groupData = { ...initialState };
            for (const key in group) {
                if (key in groupData) groupData[key] = group[key];
                groupData.group_name = group.name;
            }

            if(group.privacy) {

                // Pre-fill selected privacy option based on the group's data
                setPrivacy(group.privacy);
            }

            setFormData(groupData);
        }
    }, [group]);

    // Form Data
    const { group_name, description, location } = formData;

    // Edit profile info logic

    // Update the form data when input fields change
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

    // Handle name form submission
    const nameTodo = (e) => {
        onSubmitName(e);
    }

    // Handle description form submission
    const descriptionTodo = (e) => {
        onSubmitDescription(e);
    }

    // Handle privacy form submission
    const privacyTodo = (e) => {
        onSubmitPrivacy(e);
    }

    // Submit the name form
    const onSubmitName = async e => {
        e.preventDefault();

        if(group) {
            const groupId = group._id; 

            // Call the editGroupName function to update the group's name
            editGroupName({ 
                name: group_name,  
                groupId
            });
            
            console.log('FRONT END ID')
            console.log(groupId);
            console.log('GROUP NAME')
            console.log(group_name);
        }

        toggleNameModal();
    }

    // Submit the description form
    const onSubmitDescription = async e => {
        e.preventDefault();

        if(group) {
            const groupId = group._id; 


            // Call the editGroupDescription function to update the group's description
            editGroupDescription({ 
                description,
                groupId
            });

            console.log('FRONT END ID')
            console.log(groupId);
            console.log('BIO')
            console.log(description);
        }

        toggleDescriptionModal();
    }

    // Submit the privacy form
    const onSubmitPrivacy = async e => {
        e.preventDefault();

        if(group) {
            const groupId = group._id; 


            // Call the editGroupPrivacy function to update the group's privacy setting
            editGroupPrivacy({ 
                privacy,
                groupId
            });

            console.log('FRONT END ID')
            console.log(groupId);
            console.log('PRIVACY OPTION')
            console.log(privacy);
        }

        togglePrivacyModal();
    }

    // Modal toggle logic

    // Toggle the name modal
    const toggleNameModal = () => {
        setNameModal(!nameModal);
    }

    // Toggle the description modal
    const toggleDescriptionModal = () => {
        setDescriptionModal(!descriptionModal);
    }

    // Toggle the privacy modal
    const togglePrivacyModal = () => {
        setPrivacyModal(!privacyModal);
    }

    const bg = {
        modal: {
            paddingLeft: "0",
            paddingRight: "0",
            border:"1px solid rgb(214,214,214)",
            boxShadow: "none"
        },
        overlay: {
          background: "rgba(255,255,255,0.5)"
        }
    };

    // Handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

        mixpanel.track("Edit Group Page View");
    }

    // Trigger Mixpanel analytics on initial render
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    return (
        <Fragment>

            {/* Layout component with profile edit mode */}
            <Layout page={'group edit'}>

                {loading || !group ? <Spinner /> : (
                    
                    <GroupEdit toggleNameModal={toggleNameModal} toggleDescriptionModal={toggleDescriptionModal} togglePrivacyModal={togglePrivacyModal} />
                    
                )}
                
            </Layout>

            {/* Modal for editing display name */}
            <ModalContainer editProfile show={nameModal} onClose={toggleNameModal}>
                <Modal>
                    <h2>Edit Group Name</h2>
                    <div className="modal__inputs">

                        {/* Input fields for first name and last name */}
                        <input
                            type="text"
                            placeholder="Group Name"
                            className="input"
                            name="group_name"
                            value={group_name}
                            maxlength="75"
                            onChange={e => onChange(e)}
                        />

                        {/* Display Bio character length */}
                        <div style={{color:'rgb(27, 149, 224)', display: 'flex', justifyContent: 'flex-end', width:'95%', fontSize:'14px', overflowWrap:'break-word'}}>
                            <span>{group_name && group_name.length} / 75</span>
                        </div>

                    </div>

                    {/* Modal Actions */}
                    <div className="btnRow">

                        {/* Cancel button */}
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet ghost"
                            fullWidth
                            onClick={() => toggleNameModal()}
                        >
                            Cancel
                        </Button>

                        {/* Save button */}
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet" 
                            fullWidth
                            onClick={(e) => nameTodo(e)}
                        >
                            Save
                        </Button>
                    </div>
                </Modal>
            </ModalContainer>

            {/* Modal for editing description */}
            <ModalContainer editProfile show={descriptionModal} onClose={toggleDescriptionModal}>
                <Modal>
                    <h2>Edit Description</h2>
                    <div className="modal__inputs">

                        {/* Textarea for description */}
                        <textarea
                            style={{width:'94%', padding:'10px', minHeight:'100px', resize: 'none'}}
                            type="text"
                            placeholder="Description"
                            className="input"
                            name="description"
                            value={description}
                            maxlength="160"
                            onChange={e => onChange(e)}
                        />

                        {/* Display Bio character length */}
                        <div style={{color:'rgb(27, 149, 224)', display: 'flex', justifyContent: 'flex-end', width:'95%', fontSize:'14px', overflowWrap:'break-word'}}>
                            <span>{description && description.length} / 160</span>
                        </div>
                    </div>

                    {/* Modal Actions */}
                    <div className="btnRow">

                        {/* Cancel button */}
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet ghost"
                            fullWidth
                            onClick={() => toggleDescriptionModal()}
                        >
                            Cancel
                        </Button>

                        {/* Save button */}
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet" 
                            fullWidth
                            onClick={(e) => descriptionTodo(e)}
                        >
                            Save
                        </Button>
                    </div>
                </Modal>
            </ModalContainer>

            {/* Modal for editing description */}
            <ModalContainer editProfile show={privacyModal} onClose={togglePrivacyModal}>
                <Modal>
                    <h2>Edit Privacy</h2>
                    {/* Gender Options */}
                    <div style={{ padding:'0 10px', display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
                    
                        {/* Public */}
                        <div onClick={() => setPrivacy('public')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                            {privacy === 'public' ? (
                                <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                    <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                                </div>
                            ) : (
                                <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                            )}
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Public</p>
                                <p style={{fontSize: '13px'}}>Anyone can view and post.</p>
                            </div>
                        </div>

                        {/* Restricted */}
                        <div onClick={() => setPrivacy('restricted')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                            {privacy === 'restricted' ? (
                                <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                    <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                                </div>
                            ) : (
                                <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                            )}
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Restricted</p>
                                <p style={{fontSize: '13px'}}>Anyone can view, but only members can post.</p>
                            </div>
                        </div>
                        
                        {/* Private */}
                        <div onClick={() => setPrivacy('private')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                            {privacy === 'private' ? (
                                <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                    <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                                </div>
                            ) : (
                                <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                            )}
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Private</p>
                                <p style={{fontSize: '13px'}}>Only members can view and post.</p>
                            </div>
                        </div>

                        {/* Students Only */}
                        <div onClick={() => setPrivacy('private')} className="button-hover-class" style={{margin:'10px 0', display:'flex', justifyContent:'center', alignItems:'center'}}>
                            {privacy === 'private' ? (
                                <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'16px', width:'16px', border:'2px solid rgb(29, 155, 240)', padding:'2px', borderRadius:'50%', marginRight:'10px'}}>
                                    <div style={{height:'100%', width:'100%', background:'rgb(29, 155, 240)', borderRadius:'50%'}}></div>
                                </div>
                            ) : (
                                <div style={{height:'19px', width:'19px', border:'2px solid #cecece', borderRadius:'50%', marginRight:'10px'}}></div>
                            )}
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
                                <p style={{margin:'0', fontSize:'1rem', fontWeight: 500}}>Students only</p>
                                <p style={{fontSize: '13px'}}>Only verified students can view and post.</p>
                            </div>
                        </div>
                    </div>

                    {/* Modal Actions */}
                    <div className="btnRow">

                        {/* Cancel button */}
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet ghost"
                            fullWidth
                            onClick={() => togglePrivacyModal()}
                        >
                            Cancel
                        </Button>

                        {/* Save button */}
                        <Button 
                            variant="outlined" 
                            className="sidebar__tweet" 
                            fullWidth
                            onClick={(e) => privacyTodo(e)}
                        >
                            Save
                        </Button>
                    </div>
                </Modal>
            </ModalContainer>
        </Fragment>
    )
}

EditGroup.propTypes = {
    setPage: PropTypes.func.isRequired, 
    add_To_Recent_History: PropTypes.func.isRequired,
    editGroupName: PropTypes.func.isRequired,
    editGroupDescription: PropTypes.func.isRequired,
    editGroupPrivacy: PropTypes.func.isRequired,
    getGroupById: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired, 
    group: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth,
    group: state.group
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setPage,
    add_To_Recent_History,
    editGroupName, 
    editGroupDescription,
    editGroupPrivacy,
    getGroupById
})(EditGroup);
